import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Pencil"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-pencil',
    templateUrl: './icon-pencil.component.html',
    styleUrls: ['./icon-pencil.component.scss'],
    standalone: false
})
export class IconPencilComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
